module.exports = __webpack_public_path__ + "img/pic_suppay_appstore@3x.2012eb89.png";